import { useEffect, useState } from "react";
import { UserInfoModel } from "app/model/ua/user-info";
import { AuthenticationService } from "app/services/common/AuthenticationService";
import { HttpStatusCode } from "axios";
import { AuthContextProps } from "react-oidc-context";
import { UserInfoUtil } from "app/utils/userInfoUtil";
import { AuthConstant } from "app/constants/authConstant";
import { useAppDispatch } from "app/store/hook";
import { setUserInfo } from "app/reducers/userSlice";

const useRootPage = (auth: AuthContextProps) => {
  const dispatch = useAppDispatch();
  const [rootPage, setRootPage] = useState<string>();

  useEffect(() => {
    if (!auth.error && !auth.isLoading) {
      if (auth.isAuthenticated) {
        AuthenticationService.getInstance().getUserInfo()
        .then((response) => {
          if (response && response.data && HttpStatusCode.Ok === response.statusCode) {
            const data = new UserInfoModel(response.data);
            if (auth.user?.profile.sub === data.userId) {
              dispatch(setUserInfo(data));

              const isPvmaintUser = UserInfoUtil.hasRole(data, AuthConstant.R006);
              if (isPvmaintUser) {
                setRootPage('/pvmaint/mon');
              } else {
                setRootPage('/db');
              }
            }
          }
        })
        .catch(() => {
          setRootPage('logout');
        })
      } else {
        setRootPage('logout');
      }
    }
  }, [auth]);

  return rootPage;
};

export default useRootPage;